import {
  ApiBlueprint,
  createFrontendModule,
  discoveryApiRef,
  fetchApiRef,
  gitlabAuthApiRef,
} from '@backstage/frontend-plugin-api';
import {
  HomePageLayoutBlueprint,
  HomePageWidgetBlueprint,
} from '@backstage/plugin-home-react/alpha';
import {
  GitlabMergeRequestsClient,
  gitlabMergeRequestsApiRef,
} from './gitlab-merge-requests/GitlabMergeRequestsClient';
import { userLinksCardSettings } from './user-links/userLinks';

const gitlabMergeRequestsApi = ApiBlueprint.make({
  name: 'gitlab-merge-requests',
  params: defineParams =>
    defineParams({
      api: gitlabMergeRequestsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        gitlabAuthApi: gitlabAuthApiRef,
      },
      factory: ({ discoveryApi, fetchApi, gitlabAuthApi }) =>
        new GitlabMergeRequestsClient({
          discoveryApi,
          fetchApi,
          gitlabAuthApi,
        }),
    }),
});

const homePageLayout = HomePageLayoutBlueprint.make({
  params: {
    loader: async () => {
      const { AllosHomePageLayout } = await import('./AllosHomePageLayout');
      return AllosHomePageLayout;
    },
  },
});

const gitlabMergeRequestsWidget = HomePageWidgetBlueprint.make({
  name: 'gitlab-merge-requests',
  params: {
    name: 'HomePageGitLabMergeRequests',
    title: 'My Merge Requests',
    description: 'Open GitLab merge requests you authored or were assigned',
    components: () =>
      import('./gitlab-merge-requests/GitlabMergeRequestsCard').then(m => ({
        Content: m.Content,
      })),
    layout: {
      height: { minRows: 4 },
      width: { minColumns: 4 },
    },
  },
});

const userLinksWidget = HomePageWidgetBlueprint.make({
  name: 'user-links',
  params: {
    name: 'HomePageUserLinks',
    title: 'Links',
    description: 'Personal shortcuts that only you can see',
    components: () =>
      import('./user-links/UserLinksCard').then(m => ({
        Content: m.Content,
      })),
    settings: userLinksCardSettings,
    layout: {
      height: { minRows: 4 },
      width: { minColumns: 3 },
    },
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [
    gitlabMergeRequestsApi,
    homePageLayout,
    gitlabMergeRequestsWidget,
    userLinksWidget,
  ],
});
